shadow$provide[474] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Outlet:{enumerable:true, get:function() {
  return Outlet;
}}});
var require$_DOT__SLASH_graph = require("./graph");
class Outlet {
  static initClass() {
    this.index = 0;
  }
  static make(outlet, extra) {
    if (extra == null) {
      extra = {};
    }
    const meta = extra;
    if (outlet.meta != null) {
      for (const key in outlet.meta) {
        const value = outlet.meta[key];
        meta[key] = value;
      }
    }
    return new Outlet(outlet.inout, outlet.name, outlet.hint, outlet.type, meta);
  }
  static id(name) {
    return `_io_${++Outlet.index}_${name}`;
  }
  static hint(name) {
    name = name.replace(/^_io_[0-9]+_/, "");
    name = name.replace(/_i_o$/, "");
    return name = name.replace(/(In|Out|Inout|InOut)$/, "");
  }
  constructor(inout, name, hint, type, meta, id) {
    this.inout = inout;
    this.name = name;
    this.hint = hint;
    this.type = type;
    if (meta == null) {
      meta = {};
    }
    this.meta = meta;
    this.id = id;
    if (this.hint == null) {
      this.hint = Outlet.hint(this.name);
    }
    this.node = null;
    this.input = null;
    this.output = [];
    if (this.id == null) {
      this.id = Outlet.id(this.hint);
    }
  }
  morph(outlet) {
    this.inout = outlet.inout;
    this.name = outlet.name;
    this.hint = outlet.hint;
    this.type = outlet.type;
    return this.meta = outlet.meta;
  }
  dupe(name) {
    if (name == null) {
      name = this.id;
    }
    const outlet = Outlet.make(this);
    outlet.name = name;
    return outlet;
  }
  connect(outlet) {
    if (this.inout === require$_DOT__SLASH_graph.Graph.IN && outlet.inout === require$_DOT__SLASH_graph.Graph.OUT) {
      return outlet.connect(this);
    }
    if (this.inout !== require$_DOT__SLASH_graph.Graph.OUT || outlet.inout !== require$_DOT__SLASH_graph.Graph.IN) {
      throw new Error("Can only connect out to in.");
    }
    if (outlet.input === this) {
      return;
    }
    outlet.disconnect();
    outlet.input = this;
    return this.output.push(outlet);
  }
  disconnect(outlet) {
    if (this.input) {
      this.input.disconnect(this);
    }
    if (this.output.length) {
      if (outlet) {
        const index = this.output.indexOf(outlet);
        if (index >= 0) {
          this.output.splice(index, 1);
          return outlet.input = null;
        }
      } else {
        for (outlet of Array.from(this.output)) {
          outlet.input = null;
        }
        return this.output = [];
      }
    }
  }
}
Outlet.initClass();

};